import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import {
    Settings,
    Users,
    Shield,
    CreditCard,
    Key,
    HelpCircle,
    LogOut,
    LayoutGrid,
    Puzzle,
    FileText,
    Cpu,
    Tag
} from 'lucide-react';
import './SettingsLayout.css';
import { useAuth } from '../../context/AuthContext';

function SettingsLayout() {
    const location = useLocation();
    const { logout } = useAuth();

    // Navigation items based on mockup
    const navItems = [
        { path: '/settings/general', label: 'General', icon: Settings },
        { path: '/settings/members', label: 'Members', icon: Users },
        // { path: '/settings/roles', label: 'Roles & Permissions', icon: Shield },
        { path: '/settings/integrations', label: 'Integrations', icon: Puzzle },
        { path: '/settings/billing', label: 'Billing', icon: CreditCard },
        { path: '/settings/api-keys', label: 'API Keys', icon: Key },
        { path: '/settings/test-assets', label: 'Test Assets', icon: FileText },
        { path: '/settings/devices', label: 'Active Devices', icon: Cpu },
        { path: '/settings/categories', label: 'Categories', icon: Tag },
    ];

    return (
        <div className="settings-layout">
            <aside className="settings-sidebar">
                <div className="settings-sidebar-header">
                    Settings
                </div>
                <nav className="settings-nav">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) =>
                                `settings-nav-item ${isActive ? 'active' : ''}`
                            }
                        >
                            <item.icon size={18} />
                            <span>{item.label}</span>
                        </NavLink>
                    ))}
                </nav>
            </aside>

            <main className="settings-content-wrapper">
                <Outlet />
            </main>
        </div>
    );
}

export default SettingsLayout;
